function checkPort(pol_code, pod_code, ports) {
  let pol = ports.find((port) => port.code === pol_code);
  let pod = ports.find((port) => port.code === pod_code);

  if (!pol || !pod) {
    return "Please check and input correct fields!";
  } else {
    if (
      pol.country_code.toString().toUpperCase() !== "VN" &&
      pod.country_code.toString().toUpperCase() !== "VN"
    ) {
      return "Chưa cung cấp dịch vụ này!";
    } else if (
      pol.country_code.toString().toUpperCase() === "VN" &&
      pod.country_code.toString().toUpperCase() === "VN"
    ) {
      return "Sai dịch vụ!";

      
    }

    return "1";
  }
}

export { checkPort };
